// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "chunk." + chunkId + "--" + {"2297":"0f60dbd","3318":"e38c43d","8816":"0a38977"}[chunkId] + ".js";
};